<link-index [groupId]="route.snapshot.params.groupId"></link-index>
